'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadBatchStart = exports.loadBatchEnd = exports.isDataLoading = exports.LOAD_BATCH_START = exports.LOAD_BATCH_END = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_BATCH_END = exports.LOAD_BATCH_END = 'LOAD_BATCH_END';
var LOAD_BATCH_START = exports.LOAD_BATCH_START = 'LOAD_BATCH_START';

/* reducer */
var DEFAULT_STATE = {
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOAD_BATCH_END:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, [action.payload])
            });
        case LOAD_BATCH_START:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, [action.payload])
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.fetchBatch;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var isDataLoading = exports.isDataLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

/* ACTION CREATORS */
var loadBatchEnd = exports.loadBatchEnd = function loadBatchEnd(loadingId) {
    return {
        payload: loadingId,
        type: LOAD_BATCH_END
    };
};

var loadBatchStart = exports.loadBatchStart = function loadBatchStart(loadingId) {
    return {
        payload: loadingId,
        type: LOAD_BATCH_START
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/fetchBatch.js
// module id = 6OCT
// module chunks = 46